import { useDimensions } from "@repo/core/hooks/useDimensions";
import { format } from "date-fns";
import { useMemo } from "react";

export const ReportScreenHeaderController = () => {
  const { isMobile } = useDimensions();
  const { fetchedAtText } = useMemo(() => {
    const fetchedAtText = `Atualizado em ${format(new Date(), "dd/MM")} às ${format(new Date(), "HH:mm:ss")}`;
    return { fetchedAtText };
  }, []);
  return { isMobile, fetchedAtText };
};
